import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createBlock, createElementVNode, resolveDynamicComponent, withCtx, Fragment, createCommentVNode, toDisplayString, mergeProps, createTextVNode, renderList, createVNode } from 'vue';
import _sfc_main$3 from './basler-components.es210.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es121.js';

const _hoisted_1 = { class: "product-variant-option-group__title-text" };
const _hoisted_2 = {
  key: 0,
  class: "product-variant-option-group__title-info-text"
};
const _hoisted_3 = { class: "product-variant-option-group__list" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductVariantPickerOptionGroup",
  props: {
    title: {},
    titleInfoText: {},
    options: {},
    showAttributes: { type: Boolean },
    link: {},
    modelValue: {},
    titleTag: { default: "h4" },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["update"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const cssClassNames = computed(() => ({
      "product-variant-option-group": true,
      "product-variant-option-group--with-attributes": props.showAttributes
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(cssClassNames.value)
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.titleTag), { class: "product-variant-option-group__title" }, {
          default: withCtx(() => [
            _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              type: "block",
              style: { "width": "20%" }
            })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createElementVNode("span", _hoisted_1, toDisplayString(_ctx.title), 1),
              _ctx.titleInfoText ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(_ctx.titleInfoText), 1)) : createCommentVNode("", true),
              _ctx.link ? (openBlock(), createBlock(_sfc_main$2, mergeProps({ key: 1 }, _ctx.link, { class: "product-variant-option-group__title-link" }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.link.text), 1)
                ]),
                _: 1
              }, 16)) : createCommentVNode("", true)
            ], 64))
          ]),
          _: 1
        })),
        createElementVNode("ul", _hoisted_3, [
          _ctx.isLoading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, renderList(3, (index) => {
            return createElementVNode("li", {
              key: index,
              class: "product-detail-header-features__list-item"
            }, [
              createVNode(_sfc_main$1, {
                type: "block",
                style: { "width": "100%", "height": "52px" }
              })
            ]);
          }), 64)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.options, (option) => {
            return openBlock(), createElementBlock("li", {
              key: `${option.value}-${option.label}`,
              class: "product-variant-option-group__list-item"
            }, [
              createVNode(_sfc_main$3, mergeProps({ ref_for: true }, option, {
                "show-attributes": _ctx.showAttributes,
                "onUpdate:modelValue": ($event) => emit("update", option.value)
              }), null, 16, ["show-attributes", "onUpdate:modelValue"])
            ]);
          }), 128))
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
